// Small shared action used on PresetsPage and RunsListPage. Clicks
// create a fresh sim_scenarios doc (seeded from the caller's name +
// description) and navigate to /workbench/:id.
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SlidersHorizontal } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { sim } from "@/api/endpoints";
import { formatApiError } from "@/lib/formatApiError";

export default function OpenInWorkbenchButton({
    seedName,
    description,
    variant = "outline",
    size = "sm",
    className = "",
    testId,
    children = "Open in Workbench",
}) {
    const navigate = useNavigate();
    const [busy, setBusy] = useState(false);

    const onClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (busy) return;
        setBusy(true);
        try {
            const doc = await sim.scenarios.create({
                name: seedName || "Untitled scenario",
                description: description || null,
            });
            navigate(`/workbench/${doc.id}#section=airframe`);
        } catch (err) {
            toast.error(
                formatApiError(err, "Couldn't open scenario in Workbench"),
            );
        } finally {
            setBusy(false);
        }
    };

    return (
        <Button
            type="button"
            variant={variant}
            size={size}
            disabled={busy}
            onClick={onClick}
            data-testid={testId || "open-in-workbench"}
            className={className}
        >
            <SlidersHorizontal className="h-3.5 w-3.5 mr-1" />
            {children}
        </Button>
    );
}
